import { apiFetch, apiFetchV2 } from '@m/utils/http';

import { AddMemberDTO } from '../containers/LocationGroup/TaxContainer/types';

export const TaxService = {
  /**
   * Fetch exemptions
   */
  getLocationTaxExemptions: ({ locationId }: { locationId: number }) =>
    apiFetch(`/admin/site-group/${locationId}/tax-exemptions`),

  /**
   * Update tax exemption member expiry
   */
  updateTaxExemptionForMember: ({
    locationId,
    taxId,
    userExemptionId,
    expiryDate,
  }: {
    expiryDate: string;
    locationId: number;
    taxId: string;
    userExemptionId: string;
  }) =>
    apiFetch(`/admin/site-group/${locationId}/tax-exemptions/${taxId}/update/${userExemptionId}`, {
      method: 'PUT',
      body: {
        expiryDate,
      },
    }),

  /**
   * Fetch Exemption members
   */
  getMembers: ({ locationId, taxId }: { locationId: number; taxId: string }) =>
    apiFetch(`/admin/site-group/${locationId}/tax-exemptions/${taxId}/members`),

  /**
   * Add tax exemption to location
   */
  addTaxExemptionToLocation: ({
    locationId,
    displayName,
    taxExemptionRate,
  }: {
    displayName: string;
    locationId: number;
    taxExemptionRate: string;
  }) =>
    apiFetch(`/admin/site-group/${locationId}/tax-exemptions/create`, {
      method: 'POST',
      body: {
        taxExemptionRate: Number(taxExemptionRate),
        displayName,
      },
    }),

  /**
   * Add member to tax exemption
   */
  addMemberToTaxExemption: ({
    locationId,
    taxId,
    values,
  }: {
    locationId: number;
    taxId: string;
    values: AddMemberDTO;
  }) =>
    apiFetch(`/admin/site-group/${locationId}/tax-exemptions/${taxId}/add`, {
      method: 'POST',
      body: values,
    }),

  /**
   * Fetch zone tax rate.
   */
  getZoneTax: ({ siteId }: { siteId: number }) =>
    apiFetchV2<{ percent: number | null }>(`/v2/pricing/sites/${siteId}/taxes`),

  /**
   * @deprecated Set tax rate via PUT /admin/location/:id/detail (taxPercent field) instead.
   */
  updateZoneTax: ({ siteId, percent }: { percent: number | null; siteId: number }) =>
    apiFetchV2(`/v2/pricing/sites/${siteId}/taxes`, { method: 'POST', body: { percent } }),
};
